module.exports = __webpack_public_path__ + "static/marketing-pro-hero-stripes-5ead9db926a0bb2b77d17534fbe33fe8.png";